export const WOOCOMERCE = 'woocommerce-redirect'
export const SHOPIFY = 'shopify'
export const MAGENTO = 'magento'
export const VTEX = 'vtex'

export const CMS = {
  'woocommerce-redirect': 'woocommerce',
  shopify: 'shopify',
  magento: 'magento',
  vtex: 'vtex'
}
